// extracted by mini-css-extract-plugin
export default {"container":"LabelCell__container___qZWpT","textContainer":"LabelCell__textContainer___Qnigg","depth5":"LabelCell__depth5___VpR2r"};